<script setup lang="ts">
const store = usePortfolioStore()
const track = ref<HTMLElement | null>(null)

/** dir = -1 → اسلاید بعدی در چیدمان راست‌چین */
function slide(dir: number) {
  const el = track.value
  if (!el) return
  const card = el.firstElementChild as HTMLElement | null
  const step = card ? card.getBoundingClientRect().width + 14 : el.clientWidth * 0.8
  el.scrollBy({ left: dir * step, behavior: 'smooth' })
}
</script>

<template>
  <section id="projects" class="px-1 py-8 md:py-12">
    <div class="flex flex-wrap items-end justify-between gap-4">
      <div>
        <h2 data-reveal class="text-2xl font-extrabold md:text-3xl">
          <span class="text-accent">نمونه‌کارهای</span> من
        </h2>
        <p data-reveal class="mt-2 text-[13px] text-muted">مجموعه‌ای از پروژه‌های اخیر — برای دیدن بقیه بکشید</p>
      </div>
      <div class="flex gap-2" :class="{'md:hidden': store.projects.length < 3}">
        <button v-for="d in [1, -1]" :key="d" @click="slide(d)"
                :aria-label="d === 1 ? 'اسلاید قبلی' : 'اسلاید بعدی'"
                class="grid h-10 w-10 place-content-center rounded-full border border-line bg-surface text-ink
                       transition hover:-translate-y-0.5 hover:border-accent hover:text-accent">
          <svg viewBox="0 0 24 24" class="h-[18px] w-[18px]" fill="none" stroke="currentColor" stroke-width="1.8"
               stroke-linecap="round" stroke-linejoin="round">
            <path :d="d === 1 ? 'M9 5l7 7-7 7' : 'M15 5l-7 7 7 7'" />
          </svg>
        </button>
      </div>
    </div>

    <!-- اسلایدر: دسکتاپ ۴ اسلاید، موبایل ۱٫۳ اسلاید -->
    <div ref="track"
         class="mt-6 flex snap-x snap-mandatory gap-3.5 overflow-x-auto pb-1.5 [scrollbar-width:none]
                [&amp;::-webkit-scrollbar]:hidden">
      <NuxtLink v-for="p in store.projects" :key="p.id ?? p.slug" :to="'/projects/' + (p.slug || p.id)" data-reveal
                class="group card-base shrink-0 basis-[76%] snap-start overflow-hidden transition duration-500
                       hover:-translate-y-1 hover:border-accent/60 md:basis-[calc((100%-28px)/3)]">
        <div class="aspect-[16/10] overflow-hidden bg-surface-2">
          <img v-if="p.media" :src="p.media.url" :alt="p.title" loading="lazy" decoding="async"
               class="h-full w-full object-cover transition duration-700 group-hover:scale-105" />
        </div>
        <div class="p-4">
          <h3 class="font-bold">{{ p.title }}</h3>
          <p class="mt-1.5 text-xs leading-6 text-muted">{{ p.summary }}</p>
          <ul class="mt-3 flex flex-wrap gap-1.5">
            <li v-for="t in p.tags" :key="t"
                class="rounded-full bg-surface-2 px-2.5 py-1 text-[11px] text-accent-2">{{ t }}</li>
          </ul>
        </div>
      </NuxtLink>
    </div>
  </section>
</template>
